import ApiService from './api_services'

export function contractList () {
  return ApiService.get('/contracts')
}
